import { render, staticRenderFns } from "./batch-submit.vue?vue&type=template&id=6f0f7d28&scoped=true&"
import script from "./batch-submit.vue?vue&type=script&lang=js&"
export * from "./batch-submit.vue?vue&type=script&lang=js&"
import style0 from "./batch-submit.vue?vue&type=style&index=0&id=6f0f7d28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0f7d28",
  null
  
)

export default component.exports